import { tableDataMapping, downloadDataMapping } from '../model/DataTransformation';
import { csv as d3csv } from 'd3';
import TableGridColumns from '../model/TableColumns';
import LegacyCSVColumns from '../model/LegacyCSVConversionColumns';
import { debugMode, getStateName } from '../model/StaticVariables';

const getDataDocumentsUrl = (props) => {
    const { yearLabel, usStateLabel, scopeSlug, tractSlug } = props;
    let countyAppendix = tractSlug === 'county' ? '_county' : '';
    let countiesAppendix = tractSlug === 'county' ? '_counties' : '';
    let filename = scopeSlug === 'national' ? `SVI_${yearLabel}_US` : `${usStateLabel.replace(' ', '')}`;
    //national____
    //counties: https://svi.cdc.gov/Documents/Data/2020/csv/states_counties/SVI_2020_US_county.csv
    //census: https://svi.cdc.gov/Documents/Data/2020/csv/states/SVI_2020_US.csv

    //state_____
    //counties: https://svi.cdc.gov/Documents/Data/2020/csv/states_counties/Alabama_county.csv
    //          https://svi.cdc.gov/Documents/Data/2010/csv/states_counties/WestVirginia_county.csv
    //census: https://svi.cdc.gov/Documents/Data/2020/csv/states/Alabama.csv
    var fileBase = `https://svi.cdc.gov`;
    if (debugMode) {
        var origin = window.location.origin + '';

        if (origin === 'https://grasp_internal_test.cdc.gov' || origin.indexOf('localhost') != -1) {
            fileBase = `https://grasp_internal_test.cdc.gov/svi2021`;
        }
        if (origin === 'https://grasp_partner_test.cdc.gov') {
            fileBase = `https://grasp_partner_test.cdc.gov/svi`;
        }
    }
    return `${fileBase}/Documents/Data/${yearLabel}/csv/states${countiesAppendix}/${filename}${countyAppendix}.csv`;
};

const isNumber = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};
const transformLegacySVIObject = (item, year, tract) => {
    const columns = LegacyCSVColumns[year];
    const keys = Object.keys(columns);
    const output = {};

    for (var i = 0; i < keys.length; i++) {
        let mappedKey = keys[i];
        let legacyKey = columns[mappedKey];
        output[mappedKey] = legacyKey === '' || legacyKey === -999 ? legacyKey : item[legacyKey];
        if (isNumber(output[mappedKey])) {
            output[mappedKey] = Math.floor(parseFloat(output[mappedKey])) + '';
        }
    }
    //if year is 2010 and county
    if (tract === 'county' && year === 2010) {
        output.STATE_NAME = getStateName(item.STATE);
    }
    //if year is 2010 and census
    if (tract === 'census' && year === 2010) {
        output.STATE_NAME = item.STATE_NAME;
        output.STATE_ABBR = item.STATE_ABBR;
        output.ST = item.STATE_FIPS;
    }
    delete output.COUNTY;
    delete output.COUNTYFIPS;
    return output;
};
const getCSVData = async (props) => {
    const { yearLabel, usStateLabel, scopeSlug, tractSlug } = props;
    if (scopeSlug === 'state' && !usStateLabel) return [];
    const csvURL = getDataDocumentsUrl({ yearLabel, usStateLabel, scopeSlug, tractSlug });

    return await d3csv(csvURL).then((data) => {
        data = data.map((item) => {
            return transformLegacySVIObject(item, yearLabel, tractSlug);
        });
        return tableDataMapping(data, { GeoLevel: tractSlug, Comparison: scopeSlug, ReleaseYear: yearLabel });
    });
};

export { getCSVData };

const getCSVDataForDownload = async (props) => {
    const { yearLabel, usStateLabel, scopeSlug, tractSlug, yearColumnSlug } = props;
    if (scopeSlug === 'state' && !usStateLabel) return [];
    const csvURL = getDataDocumentsUrl({ yearLabel, usStateLabel, scopeSlug, tractSlug });

    return await d3csv(csvURL).then((data) => {
        const tableColumns = TableGridColumns[yearColumnSlug];
        return downloadDataMapping(data, { GeoLevel: tractSlug, Comparison: scopeSlug }, tableColumns);
    });
};
export { getCSVDataForDownload };
